import {
  MDBAlert, MDBBreadcrumb,
  MDBBreadcrumbItem, MDBBtn, MDBChipsInput, MDBCol, MDBDatatable, MDBIcon, MDBRow, MDBSpinner, MDBTabs, MDBTabsContent, MDBTabsItem,
  MDBTabsLink, MDBTabsPane
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import Body from "../../body/BodyPage";
import MainLinks from "../../navlinks/MainLinks";

import {
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalFooter,
  MDBModalHeader,
  MDBModalTitle,
  MDBScrollspy,
  MDBScrollspyLink,
} from "mdb-react-ui-kit";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router";
import { Tooltip } from "react-tooltip";
import {
  editACDGroup,
  getACDSpecificGroups,
} from "../../../apiclients/streamsapi_bridge";
import SaveChanges from "../../topviews/saveCancel";
import AgentACD from "./AgentACD";
import CallerACD from "./CallerACD";
import GeneralACD from "./GeneralACD";
import VoiceMailACD from "./VoiceMailACD";
function ACDQueuesSettings(props) {
  const {
    register,
    handleSubmit,
    formState,
    setValue,
    setError,
    clearErrors,
    reset,
  } = useForm({
    defaultValues: {
      acd_general: {
        name: "",
        extension: 0,
        adddids: [],
        removedids: [],
      },
    },
  });
  const location = useLocation();

  const { errors, isDirty, dirtyFields } = formState;
  const [acdInfo, setACDInfo] = useState(location.state ? location.state : {});
  const [acdInfoObj, setACDInfoObj] = useState({});
  const [acdcode, setACDCode] = useState(0);
  const [acdTitle, setACDTitle] = useState("");
  const [acdExtension, setACDExtension] = useState(0);
  const [defaultDataVal, setDefaultDataVal] = useState({});
  const [selectedPhoneNum, setSelectedPhoneNum] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  const [message, setMessage] = useState([]);
  const [checkAvailable, setCheckAvailable] = useState(false);
  const [rerender, setRerender] = useState(false);
  const navigate = useNavigate();
   const [isloading, setIsloading] = useState(false);

  useEffect(() => {
    if (successMessage) {
      setMessage(true);
      setTimeout(() => {
        setMessage(false);
        setSuccessMessage(""); // Clear the success message in the parent component
      }, 5000);
    }
  }, [successMessage]);

  async function getSpecificACDGrp() {
    try {
      const response = await getACDSpecificGroups(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        acdInfo.code
      );
      if (!response.json) {
        const message = `An error has occured: ${response.statusText}`;
        return;
      }
      const responseData = await response.json();
      if (!responseData) {
        window.alert(`info with id  not found`);
        navigate("/");
      }
      const rawData = responseData?.acd_general ?? {};
      //setACDInfoObj({ ...rawData});
      //setACDInfo(rawData);
      setACDCode(acdInfo.code);
      setACDTitle(acdInfo?.title ?? "");
      setACDExtension(acdInfo?.extensions ?? 0);
      setSelectedPhoneNum(rawData?.telephoneNumbers ?? []);
      setDefaultDataVal({
        acd_general: {
          extension: rawData?.extension ? parseInt(rawData.extension) : 0,
          name: rawData?.name ?? "",
          adddids: [],
          removedids: [],
        },
      });
      setRerender(false);
    } catch (e) {
      console.log(``);
    }
  }

  useEffect(() => {
    if (acdInfo?.code != "" || rerender) {
      getSpecificACDGrp();
    }
  }, [acdInfo.code, rerender]);

  function closeSave(e) {
    //navigate("/userlanding");
    reset();
  }

  useEffect(() => {
    if (Object.keys(defaultDataVal).length !== 0) reset(defaultDataVal);
  }, [defaultDataVal]);

  const isdirtyFields =
    Object.keys(formState.dirtyFields).length === 0 ? false : true;
  const onSubmit = async (data) => {
    const dirtyFields = formState.dirtyFields;
    const modifiedData = {};
    for (const field of Object.keys(dirtyFields)) {
      // Check if the field is dirty and exists in the data object
      if (dirtyFields[field] && data.hasOwnProperty(field)) {
        // If the field is an object, extract modified subfields
        if (typeof data[field] === "object" && !Array.isArray(data[field])) {
          modifiedData[field] = {};

          for (const subfield of Object.keys(dirtyFields[field])) {
            if (data[field].hasOwnProperty(subfield)) {
              modifiedData[field][subfield] = data[field][subfield];
            }
          }
        } else {
          modifiedData[field] = data[field];
        }
      }
    }
    if (modifiedData) {
      setCheckAvailable(false);
      modifiedData.reqid = 35;
      modifiedData.siteid = JSON.parse(
        sessionStorage.getItem("admin_session")
      ).siteid;
      modifiedData.code = acdcode;
      console.log("modified data for ACD :::" + JSON.stringify(modifiedData));
      console.log(JSON.stringify(modifiedData));
      let saverep = await editACDGroup(modifiedData);
      console.log(`reponse of Edit ACD :::: ${JSON.stringify(saverep)}`);
      let saverepeMsg = await saverep.json();
      console.log(
        "response of modified data :::" + JSON.stringify(saverepeMsg)
      );
      if (saverepeMsg.status && saverepeMsg.status == "success") {
        setRerender(true);
        setSuccessMessage(saverepeMsg.message);
      } else {
        if (saverepeMsg.message?.errors) {
          saverepeMsg.message.errors.forEach((err) => {
            setError(err.param_name, {
              type: "server",
              message: err.message,
            });
            const fieldElement = document.querySelector(
              `input[name="${err.param_name}"]`
            );
            if (fieldElement) {
              fieldElement.focus();
              fieldElement.scrollIntoView({ behavior: "smooth" });
            }
          });
        }
      }
    }
  };

  const [basicActive, setBasicActive] = useState("tab1");
  const handleBasicClick = (value) => {
    if (value === basicActive) {
      return;
    }

    setBasicActive(value);
  };

  const [verticalActive, setVerticalActive] = useState("tab1");

  const handleVerticalClick = (value) => {
    if (value === verticalActive) {
      return;
    }

    setVerticalActive(value);
  };

  const acdQueueData = {
    columns: [
      "Name",
      "Extension",
      "Role",
      "Skill Level",
      "Login Status",
      "Call Pull",
      "Presence Routing",
      "Record Calls ",
      "Dynamic Recording",
      "Recording Listening Permissions",
      "Remove",
    ],
    rows: [
      [
        "All Members In The List",
        " ",
        " ",
        " ",
        <>
          <div class="three-checkbox round2 mx-0">
            <input type="radio" name="stat" checked />
            <input type="radio" name="stat" checked />
            <input type="radio" name="stat" />
            <span class="slider"></span>
          </div>
        </>,
        <>
          <div class="three-checkbox round2 mx-0">
            <input type="radio" name="stateA" checked />
            <input type="radio" name="stateA" checked />
            <input type="radio" name="stateA" />
            <span class="slider"></span>
          </div>
        </>,
        <>
          <div class="three-checkbox round2 mx-0">
            <input type="radio" name="stateB" checked />
            <input type="radio" name="stateB" checked />
            <input type="radio" name="stateB" />
            <span class="slider"></span>
          </div>
        </>,
        <>
          <div class="three-checkbox round2 mx-0">
            <input type="radio" name="stateC" checked />
            <input type="radio" name="stateC" checked />
            <input type="radio" name="stateC" />
            <span class="slider"></span>
          </div>
        </>,
        <>
          <div class="three-checkbox round2 mx-0">
            <input type="radio" name="stateD" checked />
            <input type="radio" name="stateD" checked />
            <input type="radio" name="stateD" />
            <span class="slider"></span>
          </div>
        </>,
        <select
          className="form-control form-select  selectname w-100"
          name="San Jose"
        >
          <option value="San Jose">Listen And Download</option>
          <option value="San Jose">San Jose</option>
          <option value="San Jose">San Jose</option>
          <option value="San Jose">San Jose</option>
        </select>,

        <div className="ms-4 w-40">
          <div className="custom-hover-bg p-1 px-2 cursor-pointer deleteToolTip">
            <MDBIcon icon="times" color="primary" />
          </div>
        </div>,
      ],
      [
        "Nick Leyendecker",
        "3755",
        "Agent, Supervisor",
        <input type="text " value={5} className="w-50 form-control" />,

        <div className="phoneselect">
          <label className="switch">
            <input className="form-control" type="checkbox" />
            <span className="slider round"></span>
          </label>
        </div>,
        <div className="phoneselect">
          <label className="switch">
            <input className="form-control" type="checkbox" />
            <span className="slider round"></span>
          </label>
        </div>,
        <div className="phoneselect">
          <label className="switch">
            <input className="form-control" type="checkbox" />
            <span className="slider round"></span>
          </label>
        </div>,
        <div className="phoneselect">
          <label className="switch">
            <input className="form-control" type="checkbox" />
            <span className="slider round"></span>
          </label>
        </div>,
        <div className="phoneselect">
          <label className="switch">
            <input className="form-control" type="checkbox" />
            <span className="slider round"></span>
          </label>
        </div>,
        <select
          className="form-control form-select selectname w-100"
          name="San Jose"
        >
          <option value="San Jose">Listen And Download</option>
          <option value="San Jose">San Jose</option>
          <option value="San Jose">San Jose</option>
          <option value="San Jose">San Jose</option>
        </select>,

        <div className="ms-4 w-40">
          <div className="custom-hover-bg p-1 px-2 cursor-pointer deleteToolTip">
            <MDBIcon icon="times" color="primary" />
          </div>
        </div>,
      ],
      [
        "Michel Paxton",
        "3760",
        "Agent",
        <input
          className="form-control w-50 form-control"
          type="text "
          value={5}
        />,

        <div className="phoneselect">
          <label className="switch">
            <input className="form-control" type="checkbox" />
            <span className="slider round"></span>
          </label>
        </div>,
        <div className="phoneselect">
          <label className="switch">
            <input className="form-control" type="checkbox" />
            <span className="slider round"></span>
          </label>
        </div>,
        <div className="phoneselect">
          <label className="switch">
            <input className="form-control" type="checkbox" />
            <span className="slider round"></span>
          </label>
        </div>,
        <div className="phoneselect">
          <label className="switch">
            <input className="form-control" type="checkbox" />
            <span className="slider round"></span>
          </label>
        </div>,
        <div className="phoneselect">
          <label className="switch">
            <input className="form-control" type="checkbox" />
            <span className="slider round"></span>
          </label>
        </div>,
        <select
          className="form-control form-select selectname w-100"
          name="San Jose"
        >
          <option value="San Jose">Listen And Download</option>
          <option value="San Jose">San Jose</option>
          <option value="San Jose">San Jose</option>
          <option value="San Jose">San Jose</option>
        </select>,
        <div className="ms-4 w-40">
          <div className="custom-hover-bg p-1 px-2 cursor-pointer deleteToolTip">
            <MDBIcon icon="times" color="primary" />
          </div>
        </div>,
      ],
    ],
  };
  const acdQueueData2 = {
    columns: [
      "Name",
      "Extension",
      "Role",
      "Skill Level",
      "Login Status",
      "Call Pull",
      "Presence Routing",
      "Record Calls ",
      "Dynamic Recording",
      "Recording Listening Permissions",
      "Remove",
    ],
    rows: [
      [
        "All Members In The List",
        " ",
        " ",
        " ",
        <>
          <div class="three-checkbox round2 mx-0">
            <input type="radio" name="startE" checked />
            <input type="radio" name="startE" checked />
            <input type="radio" name="startE" />
            <span class="slider"></span>
          </div>
        </>,
        <>
          <div class="three-checkbox round2 mx-0">
            <input type="radio" name="stateF" checked />
            <input type="radio" name="stateF" checked />
            <input type="radio" name="stateF" />
            <span class="slider"></span>
          </div>
        </>,
        <>
          <div class="three-checkbox round2 mx-0">
            <input type="radio" name="stateG" checked />
            <input type="radio" name="stateG" checked />
            <input type="radio" name="stateG" />
            <span class="slider"></span>
          </div>
        </>,
        <>
          <div class="three-checkbox round2 mx-0">
            <input type="radio" name="stateH" checked />
            <input type="radio" name="stateH" checked />
            <input type="radio" name="stateH" />
            <span class="slider"></span>
          </div>
        </>,
        <>
          <div class="three-checkbox round2 mx-0">
            <input type="radio" name="stateI" checked />
            <input type="radio" name="stateI" checked />
            <input type="radio" name="stateI" />
            <span class="slider"></span>
          </div>
        </>,
        <select
          className="form-control form-select  selectname w-100"
          name="San Jose"
        >
          <option value="San Jose">Listen And Download</option>
          <option value="San Jose">San Jose</option>
          <option value="San Jose">San Jose</option>
          <option value="San Jose">San Jose</option>
        </select>,
        <div className="ms-4 w-40">
          <div className="custom-hover-bg p-1 px-2 cursor-pointer deleteToolTip">
            <MDBIcon icon="times" color="primary" />
          </div>
        </div>,
      ],
      [
        "Nick Leyendecker",
        "3755",
        "Agent, Supervisor",
        <input type="text " value={5} className="w-50 form-control" />,

        <div className="phoneselect">
          <label className="switch">
            <input className="form-control" type="checkbox" />
            <span className="slider round"></span>
          </label>
        </div>,
        <div className="phoneselect">
          <label className="switch">
            <input className="form-control" type="checkbox" />
            <span className="slider round"></span>
          </label>
        </div>,
        <div className="phoneselect">
          <label className="switch">
            <input className="form-control" type="checkbox" />
            <span className="slider round"></span>
          </label>
        </div>,
        <div className="phoneselect">
          <label className="switch">
            <input className="form-control" type="checkbox" />
            <span className="slider round"></span>
          </label>
        </div>,
        <div className="phoneselect">
          <label className="switch">
            <input className="form-control" type="checkbox" />
            <span className="slider round"></span>
          </label>
        </div>,
        <select
          className="form-control form-select selectname w-100"
          name="San Jose"
        >
          <option value="San Jose">Listen And Download</option>
          <option value="San Jose">San Jose</option>
          <option value="San Jose">San Jose</option>
          <option value="San Jose">San Jose</option>
        </select>,
        <div className="ms-4 w-40">
          <div className="custom-hover-bg p-1 px-2 cursor-pointer deleteToolTip">
            <MDBIcon icon="times" color="primary" />
          </div>
        </div>,
      ],
      [
        "Michel Paxton",
        "3760",
        "Agent",
        <input
          className="form-control w-50 form-control"
          type="text "
          value={5}
        />,

        <div className="phoneselect">
          <label className="switch">
            <input className="form-control" type="checkbox" />
            <span className="slider round"></span>
          </label>
        </div>,
        <div className="phoneselect">
          <label className="switch">
            <input className="form-control" type="checkbox" />
            <span className="slider round"></span>
          </label>
        </div>,
        <div className="phoneselect">
          <label className="switch">
            <input className="form-control" type="checkbox" />
            <span className="slider round"></span>
          </label>
        </div>,
        <div className="phoneselect">
          <label className="switch">
            <input className="form-control" type="checkbox" />
            <span className="slider round"></span>
          </label>
        </div>,
        <div className="phoneselect">
          <label className="switch">
            <input className="form-control" type="checkbox" />
            <span className="slider round"></span>
          </label>
        </div>,
        <select
          className="form-control form-select selectname w-100"
          name="San Jose"
        >
          <option value="San Jose">Listen And Download</option>
          <option value="San Jose">San Jose</option>
          <option value="San Jose">San Jose</option>
          <option value="San Jose">San Jose</option>
        </select>,
        <div className="ms-4 w-40">
          <div className="custom-hover-bg p-1 px-2 cursor-pointer deleteToolTip">
            <MDBIcon icon="times" color="primary" />
          </div>
        </div>,
      ],
    ],
  };

  const supervisorsData = {
    columns: [
      "Name",
      "Extension",
      "Call Push",
      "Call Monitor",
      "Dynamic Recording",
      "Recording Listening Permissions",
      "Remove",
    ],
    rows: [
      [
        "All Members In The List",
        " ",
        <>
          <div class="three-checkbox round2 mx-0">
            <input type="radio" name="startI" checked />
            <input type="radio" name="startI" checked />
            <input type="radio" name="startI" />
            <span class="slider"></span>
          </div>
        </>,
        <>
          <div class="three-checkbox round2 mx-0">
            <input type="radio" name="startJ" checked />
            <input type="radio" name="startJ" checked />
            <input type="radio" name="startJ" />
            <span class="slider"></span>
          </div>
        </>,
        <>
          <div class="three-checkbox round2 mx-0">
            <input type="radio" name="startK" checked />
            <input type="radio" name="startK" checked />
            <input type="radio" name="startK" />
            <span class="slider"></span>
          </div>
        </>,

        <select
          className="form-control form-select selectname w-100"
          name="San Jose"
        >
          <option value="San Jose">Listen And Download</option>
          <option value="San Jose">San Jose</option>
          <option value="San Jose">San Jose</option>
          <option value="San Jose">San Jose</option>
        </select>,
        <div className="ms-4 w-40">
          <div className="custom-hover-bg p-1 px-2 cursor-pointer deleteToolTip">
            <MDBIcon icon="times" color="primary" />
          </div>
        </div>,
      ],
      [
        "Nick Leyendecker",
        "3755",
        <div className="phoneselect">
          <label className="switch">
            <input className="form-control" type="checkbox" />
            <span className="slider round"></span>
          </label>
        </div>,
        <div className="phoneselect">
          <label className="switch">
            <input className="form-control" type="checkbox" />
            <span className="slider round"></span>
          </label>
        </div>,
        <div className="phoneselect">
          <label className="switch">
            <input className="form-control" type="checkbox" />
            <span className="slider round"></span>
          </label>
        </div>,

        <select
          className="form-control form-select  selectname w-100"
          name="San Jose"
        >
          <option value="San Jose">Listen And Download</option>
          <option value="San Jose">San Jose</option>
          <option value="San Jose">San Jose</option>
          <option value="San Jose">San Jose</option>
        </select>,
        <div className="ms-4 w-40">
          <div className="custom-hover-bg p-1 px-2 cursor-pointer deleteToolTip">
            <MDBIcon icon="times" color="primary" />
          </div>
        </div>,
      ],
      [
        "Michel Paxton",
        "3760",

        <div className="phoneselect">
          <label className="switch">
            <input className="form-control" type="checkbox" />
            <span className="slider round"></span>
          </label>
        </div>,
        <div className="phoneselect">
          <label className="switch">
            <input className="form-control" type="checkbox" />
            <span className="slider round"></span>
          </label>
        </div>,
        <div className="phoneselect">
          <label className="switch">
            <input className="form-control" type="checkbox" />
            <span className="slider round"></span>
          </label>
        </div>,

        <select
          className="form-control form-select selectname w-100"
          name="San Jose"
        >
          <option value="San Jose">Listen And Download</option>
          <option value="San Jose">San Jose</option>
          <option value="San Jose">San Jose</option>
          <option value="San Jose">San Jose</option>
        </select>,
        <div className="ms-4 w-40">
          <div className="custom-hover-bg p-1 px-2 cursor-pointer deleteToolTip">
            <MDBIcon icon="times" color="primary" />
          </div>
        </div>,
      ],
    ],
  };

  const [allAgentsActive, setAllAgentsActive] = useState("tab1");

  const handleAllAgentsClick = (value) => {
    if (value === allAgentsActive) {
      return;
    }

    setAllAgentsActive(value);
  };

  const [selectedRegion, setSelectedRegion] = useState("IN");
  const { t, i18n } = useTranslation();

  const [AddNumbers, setAddNumbers] = useState(false);
  const toggleShow12 = () => setAddNumbers(!AddNumbers);

  const section1 = useRef(null);
  const section2 = useRef(null);
  const section3 = useRef(null);
  const section4 = useRef(null);

  const containerRef = useRef(null);


  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const scrollspyLinks = document.querySelectorAll('.sticky-top .nav-link');
      const lastLink = scrollspyLinks[scrollspyLinks.length - 1];

      if (lastLink.classList.contains('active')) {
        lastLink.classList.remove('active');

        const firstLink = scrollspyLinks[0];
        if (firstLink) {
          firstLink.classList.add('active');
        }
      }
    }, 100);

    return () => clearTimeout(timeoutId);
  }, []);


  return (
    <React.Fragment>
      <>
       {isloading && (
              <>
                <div className="loadingclass">
                  <MDBBtn disabled>
                    <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                    Loading...
                  </MDBBtn>
                </div>
              </>
            )}
        <MainLinks active={2} />
        <Body
          tablinks={2}
          sublink={89}
          content={
            <>
              <section className="mb-3">
                <div className="card card-height">
                  <div className="card-header py-3 px-0">
                    <h5 className="mb-0 ">
                      <MDBBreadcrumb>
                        <MDBBreadcrumbItem>
                          <a href="/acdQueues">
                            <strong>{t("phoneSystem")}</strong>
                          </a>
                        </MDBBreadcrumbItem>
                        <MDBBreadcrumbItem active>
                          <a href="/acdQueues">
                            <strong>{t("ACDQueues")}</strong>
                          </a>
                        </MDBBreadcrumbItem>
                        <MDBBreadcrumbItem>
                          <a href="">
                            <strong> {t("supportACD")}</strong>
                          </a>
                        </MDBBreadcrumbItem>
                      </MDBBreadcrumb>
                    </h5>
                  </div>

                  <div className="card-body px-0">
                    <div className="pb-2">
                      <h5 className="fw-600 mt-2 ">{acdTitle}</h5>
                      <p className="mt-2 text-secondary">
                        Extension: {acdExtension}
                      </p>
                      <h6 className="mt-2">
                        <strong className="mt-3 mb-0">
                          Associated Call Flow
                        </strong>
                        <p className="mt-2">Main: 1000</p>
                      </h6>
                    </div>

                    <MDBTabs className="mb-3">
                      <MDBTabsItem>
                        <MDBTabsLink
                          onClick={() => handleBasicClick("tab1")}
                          active={basicActive === "tab1"}
                        >
                          {t("settings")}
                        </MDBTabsLink>
                      </MDBTabsItem>
                      <MDBTabsItem>
                        <MDBTabsLink
                          onClick={() => handleBasicClick("tab2")}
                          active={basicActive === "tab2"}
                        >
                          {t("Agents")}
                        </MDBTabsLink>
                      </MDBTabsItem>
                      <MDBTabsItem>
                        <MDBTabsLink
                          onClick={() => handleBasicClick("tab3")}
                          active={basicActive === "tab3"}
                        >
                          {t("supervisors")}
                        </MDBTabsLink>
                      </MDBTabsItem>
                    </MDBTabs>

                    <MDBTabsContent>
                      <MDBTabsPane open={basicActive === "tab1"}>
                        {/* Tab 1 content */}
                        <MDBRow>
                          <MDBCol
                            size="2"
                            md="2"
                            lg="2"
                            sm="12"
                            className="col-sm-100 pr-0 leftTabs"
                          >
                            <MDBScrollspy container={containerRef} offset={10}>
                              <MDBScrollspyLink targetRef={section1}>
                                {t("general")}
                              </MDBScrollspyLink>
                              <MDBScrollspyLink targetRef={section2}>
                                {" "}
                                {t("Agents")}
                              </MDBScrollspyLink>
                              <MDBScrollspyLink targetRef={section3}>
                                {t("caller")}
                              </MDBScrollspyLink>
                              <MDBScrollspyLink targetRef={section4}>
                                {t("Voicemail")}
                              </MDBScrollspyLink>
                            </MDBScrollspy>
                          </MDBCol>

                          <MDBCol
                            size="12"
                            md="9"
                            sm="12"
                            pr-0
                            className="col-sm-100 pr-0 leftTabContent"
                          >
                            <div className="vtabHeightHunt pr-5">
                              <div
                                id="element"
                                ref={containerRef}
                                className="scrollspy-example"
                              >
                                <form>
                                  <section ref={section1} id="section-1">
                                    <GeneralACD
                                      register={register}
                                      errors={errors}
                                      setValue={setValue}
                                      selectedPhoneNum={selectedPhoneNum}
                                      setSuccessMessage={setSuccessMessage}
                                      setError={setError}
                                      clearErrors={clearErrors}
                                      acdcode={acdcode}
                                      checkAvailable={checkAvailable}
                                      setIsloading = {setIsloading}
                                    />
                                  </section>
                                  <div className="routing-border"></div>
                                  <section ref={section2} id="section-2">
                                    <AgentACD
                                      register={register}
                                      errors={errors}
                                      setValue={setValue}
                                    />
                                  </section>
                                  <div className="routing-border"></div>
                                  <section ref={section3} id="section-3">
                                    <CallerACD
                                      register={register}
                                      errors={errors}
                                      setValue={setValue}
                                    />
                                  </section>
                                  <div className="routing-border"></div>
                                  <section ref={section4} id="section-4">
                                    <VoiceMailACD
                                      register={register}
                                      errors={errors}
                                      setValue={setValue}
                                    />
                                  </section>
                                  {isdirtyFields && (
                                    <SaveChanges
                                      onClose={closeSave}
                                      isdirtyFields={isdirtyFields}
                                      onSave={(e) => {
                                        e.preventDefault();
                                        handleSubmit(onSubmit)();
                                      }}
                                    />
                                  )}
                                </form>
                              </div>
                            </div>
                          </MDBCol>
                        </MDBRow>
                      </MDBTabsPane>

                      <MDBTabsPane open={basicActive === "tab2"}>
                        {/* Agents content */}

                        <MDBTabs className="mb-3">
                          <MDBTabsItem>
                            <MDBTabsLink
                              onClick={() => handleAllAgentsClick("tab1")}
                              active={allAgentsActive === "tab1"}
                            >
                              All Agents
                            </MDBTabsLink>
                          </MDBTabsItem>
                          <MDBTabsItem>
                            <MDBTabsLink
                              onClick={() => handleAllAgentsClick("tab2")}
                              active={allAgentsActive === "tab2"}
                            >
                              Logged-in Agents
                            </MDBTabsLink>
                          </MDBTabsItem>
                        </MDBTabs>

                        <MDBTabsContent>
                          <MDBTabsPane open={allAgentsActive === "tab1"}>
                            {/* Tab 1 content */}
                            <div className="mt-2 actionbar"></div>
                            <div className="mt-2">
                              <MDBDatatable search data={acdQueueData}
                                sortField="Name" />
                            </div>
                          </MDBTabsPane>
                          <MDBTabsPane open={allAgentsActive === "tab2"}>
                            {/* Tab 2 content */}
                            <div className="mt-2 actionbar"></div>
                            <div className="mt-2">
                              <MDBDatatable search data={acdQueueData2}
                                sortField="Name" />
                            </div>
                          </MDBTabsPane>
                        </MDBTabsContent>
                      </MDBTabsPane>
                      <MDBTabsPane open={basicActive === "tab3"}>
                        {/* Supervisors content */}
                        <div className="mt-2 actionbar"></div>
                        <div className="mt-2">

                          <MDBDatatable search data={supervisorsData}
                            sortField="Name" />
                        </div>
                      </MDBTabsPane>
                    </MDBTabsContent>
                  </div>
                  <MDBModal
                    open={AddNumbers}
                    setShow={setAddNumbers}
                    tabIndex="-1"
                  >
                    <MDBModalDialog>
                      <MDBModalContent>
                        <MDBModalHeader>
                          <MDBModalTitle>{t("add_ACDQueue")}</MDBModalTitle>
                          <MDBBtn
                            className="btn-close"
                            color="none"
                            onClick={toggleShow12}
                          ></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody>
                          <div>
                            <div>
                              <div className="form-group row">
                                <div className="col-12">
                                  <div className="form-outlines">
                                    <MDBChipsInput
                                      label="Example label"
                                      editable
                                      initialValues={[
                                        { tag: "661863 8829" },
                                        { tag: "661863 8829" },
                                        { tag: "MDBVue" },
                                      ]}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <label className="selectall pt-2">
                              {t("selectAll")}
                            </label>
                            <div>
                              <div className="routing-numbers">
                                <div className="numberadd-green">
                                  661863 8829
                                </div>
                                <div className="numberadd-green">
                                  661863 8829
                                </div>
                                <div className="numberadd">661863 8829</div>
                                <div className="numberadd">661863 8829</div>
                                <div className="numberadd">661863 8829</div>
                              </div>
                              <div className="routing-numbers">
                                <div className="numberadd">661863 8829</div>
                                <div className="numberadd">661863 8829</div>
                                <div className="numberadd">661863 8829</div>
                                <div className="numberadd">661863 8829</div>
                                <div className="numberadd">661863 8829</div>
                              </div>
                            </div>
                          </div>
                        </MDBModalBody>
                        <MDBModalFooter>
                          <MDBBtn color="secondary" onClick={toggleShow12}>
                            {t("close")}
                          </MDBBtn>
                          <MDBBtn>{t("add")}</MDBBtn>
                        </MDBModalFooter>
                      </MDBModalContent>
                    </MDBModalDialog>
                  </MDBModal>
                </div>
              </section>
            </>
          }
        />
        {successMessage && (
          <MDBAlert
            open
            className="alert-center"
            color="success"
            autohide
            position="bottom-right"
            delay={10000}
          >
            <i className="fas fa-check-circle me-3"></i>
            <span className="alert-msg">{successMessage}</span>
          </MDBAlert>
        )}
        {/* <Footer /> */}
      </>
      <Tooltip anchorSelect=".deleteToolTip" place="top" className="exampleTooltip">
        Remove
      </Tooltip>
    </React.Fragment>
  );
}

export default ACDQueuesSettings;
